import React, {useState, useEffect} from "react";
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useCookies } from 'react-cookie';
import Loader1 from '../global-component/Loader1';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import swal from "sweetalert2";
import InputGroup from 'react-bootstrap/InputGroup';
import jQuery from "jquery";
import $ from "jquery";

function LoginMicrosoft() {
  const [apiKey, setApiKey] = useState('87d7263abc094f35a77b313760406905');
  const [cookies, setCookie] = useCookies(['access_token', 'refresh_token']);
  const [loading, setLoading] = useState(false);
     async function  fetchcurrentcountry(){
        fetch('https://api.ipify.org/?format=json')
        .then(response => response.json())
        .then(data =>getcountrydata(data.ip))
        .catch(error => console.error('Error fetching IP address:', error));
      };
      
    async function getcountrydata(ip){
        fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${apiKey}&ip=${ip}`)
        .then(response => response.json())
        .then(data => showcountrydata(data))
        .catch(error => console.error('Error fetching IP details:', error));
    }
    
    async function showcountrydata(data){       
        $("#country").val(data.country_name);
        $("#currency").val(data.currency.code);
        $("#countrycode").val(data.calling_code);
    }

    async function fetchlogindetails(regid){      

        try {
            const response = await fetch('https://zwt.zwato.com/Invoice.aspx/GetCompanyDetails', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json; charset=utf-8'       
              },
              body: JSON.stringify({
                registrationid: regid       
              })
            });
            const data = await response.json();           
           //console.log(data.d.address1);  

         let expires = new Date()
         expires.setTime(expires.getTime() + (86000 * 1000));         
         setCookie('access_token', data.d.registrationid+''+data.d.ipaddress, { path: '/',  expires});
         setCookie('registrationid', data.d.registrationid, { path: '/',  expires});

         localStorage.setItem('email', data.d.email);
         localStorage.setItem('currency', data.d.Currency);
         localStorage.setItem('sitelanguage', data.d.language);
         localStorage.setItem('dateformate', data.d.dateformate);        
         

        window.location.href = '/dashboard';
        return false;

        
          } catch (error) {
            // Handle errors here
            console.log("Test Error");
          }

      };

      async function fetchlogindatafromserver(code){      
        const axios = require('axios');

        let datas = JSON.stringify({
          "codedata": {           
            "codes": code,
            "country":  $("#country").val(),
            "currency": $("#currency").val(),
            "countrycode": $("#countrycode").val() 
          }
        });
        console.log(datas);
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          //url: 'http://zwato.com/DataApi/UserAccount.aspx/AddBankAccount',
          headers: { 
            'Content-Type': 'application/json'
          },
          body : datas
        };
        
        fetch('https://zwt.zwato.com/loginmicrosoft.aspx/ReactLoginwithMicrosoft', config)
        .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json(); // Extract the response body as JSON
          })
          .then(data => {           
            if (data.d === 'AccessDenied') {          
              swal.fire({
                title: '<span style="color:#f27474">Opps!</span>',
                html: "Access Denied <br /><br /><a href='javascript:swal.close();' class='btn btn-primary btn-sm'>OK</a>",
                type: 'error',
                icon: "error",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false
            });
            }       
            else {
                fetchlogindetails(data.d); 
            }
          })      
        .catch((error) => {
         // console.log("Test Error-"+error);
          alert(error +" - Please check internet connection or API");          
          setLoading(false);
        });

      };


    useEffect(() => {
     // fetchcurrentcountry();
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let code = params.get('code'); 
 //alert(code);

fetchlogindatafromserver(code);

   

}, []);

    let publicUrl = process.env.PUBLIC_URL + '/'
    return (
<>
<input type="hidden" id="country"/>
<input type="hidden" id="currency"/>
<input type="hidden" id="countrycode"/>
</>
    );

}
export  default LoginMicrosoft;
    